/* eslint-disable react/style-prop-object */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect } from 'react'
import {
  Header,
  Footer,
  Profile_Upload,
  Profile_Input,
  Profile_TextArea,
  Profile_Select_Input,
  Button,
  Snackbar,
  Loading,
} from '../../../components/index'
import { UploadsUrl } from '../../../services/url'
import { WebApi } from '../../../api/web'
import { Errors } from '../../../utilities/error'

const Edit = () => {
  const [avatar, setAvatar] = useState('/images/default-avatar.png')
  const [loading, setLoading] = useState(false)
  const [provinces, setProvinces] = useState([])
  const [profileData, setPofileData] = useState({})
  const [cities, setCities] = useState([])

  useEffect(() => {
    Provinces()
    Profile()
  }, [])
  const handleInputs = (e) => {
    if (e.target.files) {
      const name = e.target.name
      const val = e.target.files[0]
      setPofileData((prev) => {
        return {
          ...prev,
          [name]: val,
        }
      })
    } else {
      const name = e.target.name
      const val = e.target.value
      setPofileData((prev) => {
        return {
          ...prev,
          [name]: val,
        }
      })
    }
  }
  const Profile = async () => {
    setLoading(true)
    await WebApi.profile()
      .then((res) => {
        setPofileData({
          avatar: res.data.data.user.avatar,
          city: res.data.data.user.city && res.data.data.user.city._id,
          province:
            res.data.data.user.province && res.data.data.user.province._id,
          fname: res.data.data.user.fname,
          lname: res.data.data.user.lname,
          mobile: res.data.data.user.mobile,
          phone: res.data.data.user.phone,
          postcode: res.data.data.user.postcode,
        })
        setAvatar(`${UploadsUrl}/${res.data.data.user.avatar}`)
        chooseCityProfile(res.data.data.user.province._id)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }
  const Provinces = async () => {
    await WebApi.provinces()
      .then((res) => {
        setProvinces(res.data.data.provinces)
      })
      .catch((err) => {})
  }
  const chooseProvinces = async (event) => {
    if (event) {
      handleInputs(event)
      await WebApi.cities(event.target.value)
        .then((res) => {
          setCities(res.data.data.cities)
        })
        .catch((err) => console.log(err))
    }
  }
  const chooseCity = (event) => {
    if (event.target.value) {
      handleInputs(event)
    }
  }
  const UpdateProfile = async () => {
    setLoading(true)
    await WebApi.updateProfile(profileData)
      .then((res) => {
        setLoading(false)
        if (res.data.data.updateUserProfile.changedMobile) {
          localStorage.setItem(
            'userMobile',
            res.data.data.updateUserProfile.user.mobile
          )
          localStorage.removeItem('token')
          window.location.href = '/editVerification'
        } else {
          Snackbar({
            title: 'موفق',
            message: 'ویرایش شما با موفقیت انجام شد',
            type: 'success',
          })
        }
      })
      .catch((err) => {
        setLoading(false)
        Snackbar({
          title: 'نا موفق',
          message: Errors[err.response.data.errors[0].message],
          type: 'danger',
        })
      })
  }
  const chooseCityProfile = async (id) => {
    await WebApi.cities(id)
      .then((res) => {
        setCities(res.data.data.cities)
      })
      .catch((err) => console.log(err))
  }

  return (
    <>
      <Header title='ویرایش اطلاعات کاربری' />
      {loading && <Loading />}
      <div className='container'>
        <div className='template-pages'>
          <div className='profile-edit'>
            <div className='avatar'>
              <img src={avatar} alt='avatar' className='box-shadow' />
            </div>
            <Profile_Input
              name='fname'
              value={profileData.fname}
              Onchange={handleInputs}
              icon={<img src='/svg/Light/Profile.svg' alt='profile' />}
              title='نام'
            />
            <Profile_Input
              name='lname'
              value={profileData.lname}
              Onchange={handleInputs}
              icon={<img src='/svg/Light/Profile.svg' alt='profile' />}
              title='نام خانوادگی'
            />
            <Profile_Upload
              name='avatar'
              handleInputs={handleInputs}
              icon={<img src='/svg/Light/Upload.svg' alt='upload' />}
              title='آپلود تصویر آواتار'
              caption='JPEG.PNG'
              accept={'.jpg,.png'}
              setAvatar={setAvatar}
            />
            {/* <Profile_TextArea
              name='address'
              value={profileData.address}
              Onchange={handleInputs}
              icon={<img src='/svg/Light/Location.svg' alt='Location' />}
              title='نشان دقیق'
            /> */}
            <Profile_Input
              name='phone'
              value={profileData.phone}
              Onchange={handleInputs}
              icon={<img src='/svg/Light/Calling.svg' alt='Calling' />}
              title='شماره تلفن ثابت'
            />
            <Profile_Input
              name='mobile'
              value={profileData.mobile}
              Onchange={handleInputs}
              icon={<img src='/svg/Light/Calling.svg' alt='Calling' />}
              title='شماره تلفن همراه'
            />
            <Profile_Select_Input
              title='انتخاب استان'
              name={'province'}
              icon={<img src='/svg/Light/Location.svg' alt='Location' />}
              data={provinces}
              value={profileData.province}
              OnClick={chooseProvinces}
            />
            <Profile_Select_Input
              title='انتخاب شهر'
              name={'city'}
              icon={<img src='/svg/Light/Location.svg' alt='Location' />}
              data={cities}
              value={profileData.city}
              OnClick={chooseCity}
            />

            <Profile_Input
              name='postcode'
              value={profileData.postcode}
              Onchange={handleInputs}
              icon={<img src='/svg/Light/More Square.svg' alt='More' />}
              title='کد پستی'
            />
            <Button
              title='ویرایش'
              OnClick={UpdateProfile}
              style={'button-form'}
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
export default Edit
